<template lang="pug">
  include ../mixins
  div
    +b.contact-square-container.u-display--hidden.--block-xxl
      +b.square-container.--flex_start
        +e.square.--message.--nb_angle1.--width_v1
          bem-text(
            tag="p"
            size="3xs"
            color="white"
          ) {{_('Привіт! Мене звати Тімофеева Катерина')}}
      +b.square-container.--flex_end
        +e.square.--message.--width_v4.--blue
          bem-text(
            tag="p"
            size="3xs"
            color="white"
          ) {{_('Заповнюй форму, та менеджер зв`яжется з тобою')}}
    +b.ls-card--space_3sm.--color_accent-1.--border_3sm-adaptive.pos--relative
      ui-preloader(
        :class="{'is-active': isLoad}"
        loader-color="loader-wrapper__bg--accent-1"
        loader-class="loader--variant_absolute"
      )
      +b.modal-close--common.BUTTON(
        tabindex="-1"
        @click="$emit('close')"
      )
      bem-text.ma--top_3xs-xxl.ma--bottom_3sm(
        tag="p"
        color="white"
        size="md"
        weight="semi-bold"
      ) {{_("Форма зв'язку")}}
      validation-observer(
        tag="form"
        ref="observer"
        v-slot="{ errors }"
        @submit.prevent="validateBeforeSubmit"
        @keyup.enter="validateBeforeSubmit"
      )
        +b.form.ma--bottom_sm.pos--relative(v-for="input in formModel")
          template(v-if="input.view === 'input'")
            component(
              :is="input.component"
              :rules="input.rules"
              :type="input.type"
              :inputmode="input.type"
              :label-class="input.labelClass"
              :class-name="input.className"
              :placeholder="input.placeholder"
              v-model="formdata[input.model]"
              :required="input.required"
              :name="input.name"
              :mask="input.mask"
              :options="input.options"
              @keyup.enter="validateBeforeSubmit"
            )
          div(
            v-if="input.view === 'multiselect'"
            v-tooltip.hover.ios="input.tooltip && options[input.options].length === 0 ? {content: input.tooltip } : { visible: false }")
            component(
              is="control-multiselect-pure"
              :rules="input.rules"
              :options="options[input.options]"
              :class="input.className"
              :placeholder="input.placeholder"
              :track-by="input.trackBy"
              v-model="formdata[input.model]"
              :label="input.label"
              :name="input.name"
              :disabled="options[input.options].length === 0"
              @input="input.handler"
            )
        privacy-rules.ma.ma--bottom_sm(
          :rules-terms="objectItem.rules"
          :privacy="objectItem.privacy"
        )
        bem-button(
          width="full"
          block="ls-button"
          appearance="yellow-arrow"
          :disabled="isLoad"
          @event="validateBeforeSubmit()"
        ) {{_('відіслати')}}
</template>

<script>
import FormMixin from '@/js/mixins/form.mixin.js'
import { contactResource } from '@/js/services/common.service.js'
import {
  schoolsCitiesResource,
} from '@/js/services/additional.service.js'
import { mapState } from 'vuex'

export default {
  name: 'contact-form-modal',
  mixins: [FormMixin],
  components: {
    'privacy-rules': () => import('@/js/components/Forms/PrivacyRules'),
  },
  props: {
    objectItem: Object,
  },
  data() {
    return {
      formdata: {
        name: '',
        phone: '',
        // email: '',
        // direction: '',
        // typeDirection: '',
        school: '',
        isLoad: false,
      },
      formModel: [
        {
          component: 'control-input-pure',
          view: 'input',
          rules: 'alpha_spaces|required',
          type: 'text',
          className: 'form__input form__input--white',
          placeholder: this._('Вашe ім’я *'),
          model: 'name',
          required: true,
          name: 'name',
          options: null,
        },
        {
          component: 'control-tel-input-pure',
          view: 'input',
          rules: 'required',
          type: 'number',
          className: 'form__input form__input--white',
          placeholder: this._('Ваш телефон *'),
          model: 'phone',
          required: true,
          name: 'phone',
          options: null,
        },
        // {
        //   component: 'control-input-pure',
        //   view: 'input',
        //   rules: 'email|required',
        //   type: 'email',
        //   labelClass: 'form__label form__label--white',
        //   className: 'form__input form__input--white',
        //   placeholder: this._('Ваш e-mail *'),
        //   model: 'email',
        //   required: true,
        //   name: 'email',
        //   options: null,
        // },
        // {
        //   component: 'control-multiselect-pure',
        //   view: 'multiselect',
        //   rules: 'required',
        //   className: 'common-multiselect common-multiselect--white',
        //   placeholder: this._('Направление *'),
        //   model: 'direction',
        //   required: true,
        //   options: 'directionsList',
        //   trackBy: 'id',
        //   label: 'title',
        //   name: 'direction',
        //   handler: this.getDirectionsTypes,
        // },
        // {
        //   component: 'control-multiselect-pure',
        //   view: 'multiselect',
        //   rules: 'required',
        //   className: 'common-multiselect common-multiselect--white',
        //   placeholder: this._('Тип направления *'),
        //   model: 'typeDirection',
        //   required: true,
        //   options: 'directionTypesList',
        //   trackBy: 'id',
        //   label: 'title',
        //   name: 'typeDirection',
        //   tooltip: this._('Сначала выберите направление'),
        // },
        {
          component: 'control-multiselect-pure',
          view: 'multiselect',
          rules: 'required',
          className: 'common-multiselect common-multiselect--white',
          placeholder: this._('Школа *'),
          model: 'school',
          required: true,
          options: 'schoolsList',
          trackBy: 'id',
          label: 'title',
          name: 'school',
        },
      ],
      options: {
        // directionsList: [],
        // directionTypesList: [],
        schoolsList: [],
      },
    }
  },

  computed: {
    ...mapState('users/auth', [
      'user',
    ]),
  },

  watch: {
    // 'formdata.direction': {
    //   handler() {
    //     this.formdata.typeDirection = ''
    //   },
    // },
    user: {
      immediate: true,
      deep: true,
      handler(nval) {
        if (window.isAuthenticated) {
          this.setUserInfo(nval)
        }
      },
    },
  },
  mounted() {
    // this.getDirections()
    this.getSchools()
  },

  methods: {
    setUserInfo(data) {
      const { info } = data
      this.formdata.phone = info.phone
      if ('company' === info.typeUser) {
        this.formdata.name = info.firstNameContact
      } else {
        this.formdata.name = info.firstName
      }
    },

    async send(data) {
      this.isLoad = true
      const copyData = await this.prepareData({ ...data })
      return contactResource.execute({}, copyData)
        .then(res => {
          this.isLoad = false
          this.handleResponse({ res, modal: true })
        })
    },
    // getDirections() {
    //   return directionResource.execute({}, {})
    //     .then(({ data: { item: { items } } }) => {
    //       this.options.directionsList = items
    //     })
    // },
    // getDirectionsTypes() {
    //   const id = valueFromSelect(this.formdata.direction, 'id')
    //   return directionTypesResource.execute({}, { idDirection: id })
    //     .then(({ data: { item: { items } } }) => {
    //       this.options.directionTypesList = items
    //     })
    // },

    getSchools() {
      return schoolsCitiesResource.execute({}, {})
        .then(({ data: { item: { items } } }) => {
          this.options.schoolsList = items
        })
    },
  },
}
</script>
